import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-md';
import { withRouter, Redirect } from 'react-router-dom';
import Desk from './Presentational/Desk';
import { get } from 'lodash-es';

import * as salesRoutesActions from '../../Services/SalesRoutes/actions';

import './NewSalesRoute.scss';

class NewSalesRoute extends Component {
  componentDidMount() {
    const { actions, dateFormat, questionnaires } = this.props;
    if (Array.isArray(questionnaires) && questionnaires.length === 0)
      actions.fetchQuestionnaires({ date: new Date(), dateFormat });
  }

  handleActionClick = ({ action, questionnaire }) => {
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    const payload = {
      salesRoute: {
        questionnaire: {
          id: questionnaire?.id,
          code: questionnaire?.code,
        },
      },
    };

    switch (action) {
      case 'create':
        // eslint-disable-next-line react/prop-types
        actions.createSalesRoute({ payload });
        break;
      default:
        break;
    }
  };

  render() {
    const { pageTitle, canonical, questionnaires = [], strings, redirectSR /* , isCreatingSalesRoute */ } = this.props;

    const to = {
      pathname: `/salesroutes/${redirectSR}`,
      state: { from: this.location },
    };

    if (redirectSR) {
      return <Redirect push to={to} preserveQueryString={false} />;
    }

    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || pageTitle}</title>
        <meta name="description" content={strings[pageTitle] || pageTitle} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    return (
      <div className="coog-app new-salesroute">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || pageTitle}</h1>
        <Grid className="coog-grid new-salesroute-3242ae235733a23ba2886b">
          {/* {questionnaires?.map(questionnaire => (!isCreatingSalesRoute ? Card(questionnaire) : '...'))} */}
          <Desk questionnaires={questionnaires} onClick={this.handleActionClick} />
        </Grid>
      </div>
    );
  }
}

NewSalesRoute.propTypes = {
  actions: PropTypes.shape({
    fetchQuestionnaires: PropTypes.func,
    fetchNewSalesRoute: PropTypes.func,
    setRedirectStatus: PropTypes.func,
  }).isRequired,
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  isLoadingQuestionnaires: PropTypes.bool.isRequired,
  isCreatingSalesRoute: PropTypes.bool.isRequired,
  questionnaires: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
      title: PropTypes.string,
      theme: PropTypes.string,
    })
  ),
  redirectSR: PropTypes.string,
};

NewSalesRoute.defaultProps = {
  actions: {},
  pageTitle: 'title.salesroute.create',
  canonical: 'http://www.coopengo.com/',
  isLoadingQuestionnaires: false,
  isCreatingSalesRoute: false,
  questionnaires: [],
  strings: {},
  redirectSR: null,
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => {
  const questionnaires = get(state.toJS(), 'salesroutes.questionnaires', []);
  const isLoadingQuestionnaires = get(state.toJS(), 'salesroutes.loading.isLoadingQuestionnaires', false);
  const isCreatingSalesRoute = get(state.toJS(), 'salesroutes.loading.isCreatingSalesRoute', false);

  return {
    questionnaires,
    isLoadingQuestionnaires,
    isCreatingSalesRoute,
    strings: state.toJS().salesroutes.strings,
    redirectSR: state.getIn(['salesroutes', 'current']),
  };
};
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...salesRoutesActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewSalesRoute));
